import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  bgColor: "线条颜色",
  bgColorIsThemeColor: "线条颜色是否跟随主题色",
  lineType: "线条类型",
  borderWidth: "线条粗细",
  "boxShadowColor.0": "阴影颜色1",
  "animateSets.animateType": "动画类型",
  "animateSets.animateDirection": "动画方向",
  "animateSets.animateDuration": "动画持续时间"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
